// fix a element bug: https://github.com/ElemeFE/element/issues/12742
export function cancelReadOnly(el) {
  const input = el.querySelector(".el-select__input");
  if (input) {
    input.removeAttribute("readonly");
  } else {
    console.error(
      "Could not fix el select input, src/directives/select-readonly",
    );
  }
}
